export const CAP_TABLE_TEMPLATE_LINK =
  "https://docs.google.com/spreadsheets/d/1s5d20fE4OW_iXjxABHZx5sbbGnkPkP12/edit?usp=sharing&ouid=105144308529639380441&rtpof=true&sd=true";
